import { AxiosInstance, AxiosResponse } from "axios"

export interface GetDeviceIdResponse extends AxiosResponse {
  data: string
}
export function getDeviceIdApi(
  axiosInstance: AxiosInstance,
): Promise<GetDeviceIdResponse> {
  return axiosInstance({
    data: { avoidClientSideAuth: true },
    method: "get",
    url: "/device-id",
  }) as Promise<GetDeviceIdResponse>
}
